import { FC } from "react";
import { Flex, Box, Text } from "@smile2impress/components/relaunch";
import { Picture } from "@smile2impress/components";

import Link from "components/Link";

import { SimpleColumnProps } from "./SimpleColumn.types";

export const SimpleColumn: FC<SimpleColumnProps> = ({
    title,
    subtitle,
    image,
    link,
}) => {
    return (
        <Flex
            direction="column"
            justifyContent="space-between"
            bgColor="bg.grey"
            p={2}
            borderRadius="sm"
            alignSelf="stretch"
            width="100%"
            h="100%"
            rowGap={[0.7, 0.7, 1]}
            {...(link && {
                as: Link,
                href: link,
            })}
        >
            <Flex direction="column" rowGap={2}>
                <Box
                    aspectRatio={["1/1"]}
                    borderRadius="xs"
                    overflow="hidden"
                    bgColor="base.white"
                >
                    <Picture {...image} />
                </Box>
                <Text
                    textStyle={"caption"}
                    _dark={{
                        color: "text.baseInverse",
                    }}
                >
                    {title}
                </Text>
            </Flex>
            {subtitle && (
                <Flex>
                    <Text
                        textStyle={"caption"}
                        fontWeight="bold"
                        color="text.primary"
                    >
                        {subtitle}
                    </Text>
                </Flex>
            )}
        </Flex>
    );
};
